import React from 'react';

const AiPerformance = ({ performanceData, isLoading }) => {
  const { successRate, detectionRisk, avgAnalysisTime, modelVersion, capabilities } = performanceData || {
    successRate: 83, // Default values
    detectionRisk: "Low",
    avgAnalysisTime: "3m 12s",
    modelVersion: "v3.5",
    capabilities: [
      { name: "Plugin Analysis", enabled: true },
      { name: "Config Scanning", enabled: true },
      { name: "Version Detection", enabled: true },
      { name: "Exploit Matching", enabled: true },
      { name: "Adaptive Learning", enabled: true },
      { name: "Report Generation", enabled: true },
    ]
  };

  const getRiskColor = (risk) => {
    if (risk?.toLowerCase() === 'low') return 'text-accent-green';
    if (risk?.toLowerCase() === 'medium') return 'text-accent-yellow';
    if (risk?.toLowerCase() === 'high') return 'text-accent-red';
    return 'text-gray-400';
  };

  return (
    <div className={`bg-dark-600 rounded-2xl p-6 h-full flex flex-col transform-gpu hover:scale-[1.005] transition-medium border border-dark-400 hover:border-accent-blue/50 hover:shadow-glow-blue group relative overflow-hidden ${isLoading ? 'opacity-70' : ''}`}>
      <div className="absolute -right-16 -bottom-16 w-48 h-48 bg-accent-blue opacity-[0.03] rounded-full blur-3xl group-hover:opacity-[0.06] transition-opacity duration-300"></div>
      <h3 className="font-bold text-lg mb-6 flex items-center relative z-10">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-accent-blue/80 to-accent-green/80 flex items-center justify-center mr-3 shadow-md group-hover:scale-110 transition-transform duration-300">
          <i className="fas fa-chart-bar text-white"></i>
        </div>
        AI Performance
      </h3>

      {isLoading ? (
        <div className="space-y-4 flex-1">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-20 bg-dark-500 rounded-lg animate-pulse"></div>
          ))}
        </div>
      ) : (
        <div className="space-y-5 flex-1 relative z-10">
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-dark-500 rounded-xl p-4 shadow-lg transition-all duration-300 hover:shadow-accent-green/20 hover:bg-dark-400/50">
              <div className="text-xs text-gray-400 mb-1 group-hover:text-gray-200 transition-colors">Success Rate</div>
              <div className={`font-bold text-3xl ${successRate >= 80 ? 'text-accent-green' : successRate >= 60 ? 'text-accent-yellow' : 'text-accent-red'}`}>
                {successRate}%
              </div>
            </div>
            <div className="bg-dark-500 rounded-xl p-4 shadow-lg transition-all duration-300 hover:shadow-yellow-500/20 hover:bg-dark-400/50">
              <div className="text-xs text-gray-400 mb-1 group-hover:text-gray-200 transition-colors">Detection Risk</div>
              <div className={`font-bold text-3xl ${getRiskColor(detectionRisk)}`}>{detectionRisk}</div>
            </div>
            <div className="bg-dark-500 rounded-xl p-4 shadow-lg transition-all duration-300 hover:shadow-blue-500/20 hover:bg-dark-400/50">
              <div className="text-xs text-gray-400 mb-1 group-hover:text-gray-200 transition-colors">Avg. Analysis Time</div>
              <div className="font-bold text-xl text-gray-200">{avgAnalysisTime}</div>
            </div>
            <div className="bg-dark-500 rounded-xl p-4 shadow-lg transition-all duration-300 hover:shadow-purple-500/20 hover:bg-dark-400/50">
              <div className="text-xs text-gray-400 mb-1 group-hover:text-gray-200 transition-colors">AI Model Version</div>
              <div className="font-bold text-xl text-gray-200">{modelVersion}</div>
            </div>
          </div>

          <div className="bg-dark-500 rounded-xl p-4 shadow-lg transition-all duration-300 hover:shadow-indigo-500/20 hover:bg-dark-400/50">
            <h4 className="text-sm font-medium text-gray-200 mb-3">AI Capabilities</h4>
            <div className="grid grid-cols-2 gap-3">
              {capabilities.map((cap, index) => (
                <div key={index} className={`flex items-center p-2 rounded-lg transition-all duration-200 ${cap.enabled ? 'bg-dark-700 hover:bg-dark-400/70' : 'bg-dark-700 opacity-60'}`}>
                  <i className={`fas ${cap.enabled ? 'fa-check-circle text-accent-green' : 'fa-times-circle text-accent-red'} mr-2`}></i>
                  <span className="text-xs text-gray-300 group-hover:text-white transition-colors">{cap.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AiPerformance;